
<template>
	<div class="section-container">
		<div
			class="d-flex mb-4 section-title-container wrap txt-center align-center"
			:style="`color:${globalColors.primary}`"
		>
			<truck-svg />
			<h2 class="uppercase section-title">¿COMÓ QUIERES RECIBIR TU PRODUCTO?</h2>
		</div>
		<section class="mb-3 d-flex space-between align-center">
			<special-button
				v-if="isDelivery"
				text="Envío a domicilio"
				class="flex-40 mx-1"
				:value="houseReception"
				@on-click="clicked(1)"
			>
				<location-svg slot="svg" :active="houseReception"/>
			</special-button>
			<special-button
				v-if="isStore"
				class="flex-40 mx-1"
				text="Recoger en tienda"
				:value="storeReception"
				@on-click="clicked(2)"
			>
				<store-svg slot="svg" :active="storeReception"/>
			</special-button>
		</section>
		<section v-if="houseReception">
			<responsible-form/>
			<select-address-component
				:no-map="false"
				class="mb-3 mx-1"
				placeholder="Dirección"
				item-text="name"
				item-value="id"
				:options="housesAddress"
				v-model="houseAddress"
				@input="updateAddress"
			/>
		</section>
		<section v-if="newAddressFlag && houseReception">
			<address-form/>
		</section>
		<section v-if="storeReception">
			<select-address-component
				class="mb-3 mx-1"
				placeholder="Dirección"
				item-text="name"
				item-value="id"
				item-title="name"
				v-model="storeAddress"
				:options="storesAddress"
				@input="updateAddress"
			/>
			<responsible-form/>
		</section>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import specialButton from '@/components/buy/specialButton';
import selectAddressComponent from '@/components/selectAddressComponent';
import responsibleForm from '@/components/buy/responsibleForm';
import addressForm from '@/components/buy/addressForm';
import locationSvg from '@/components/svg-components/locationSvg';
import storeSvg from '@/components/svg-components/storeSvg';
import lib from '@/helpers/lib';
import truckSvg from '@/components/svg-components/truck';
import commerceData from '@/mixins/commerceData';
import { delivery, store } from '@/shared/enums/waysDeliveries';

const { getDeeper, equality } = lib;

function created() {
	this.loadData();
}

function clicked(place) {
	this.active = place;
	this.$store.commit('UPDATE_FLAG_PICK_UP', place);
	const id = place === 1 ? this.houseAddress : this.storeAddress;
	this.updateAddress(id);
	if (place === 2) {
		this.$store.commit('SET_SHIPPING_COST', null);
	}
	this.setWarehouseOrDirection();
}

function storeReception() {
	return this.active === 2;
}

function houseReception() {
	return this.active === 1;
}

async function loadData() {
	const headers = {
		Authorization: `Bearer ${this.token}`,
	};
	const requests = [
		this.$httpQtc.get('warehouse-public?flagEcommerce=1'),
		this.$httpJapi.get('customers-address', { headers }),
	];
	const [
		{ data: warehouses },
		{ data: address },
	] = await Promise.all(requests);
	this.housesAddress = this.housesAddress.concat(address);
	this.storesAddress = this.storesAddress.concat(warehouses);
	this.setWarehouseOrDirection();
}

function setWarehouseOrDirection() {
	const deliveryId = getDeeper('id')(this.deliveryAddress);
	if (this.flagPickUp === 1) {
		const { id: houseId } = this.housesAddress.find(h => h.id === deliveryId) || {};
		this.houseAddress = houseId || this.favoriteDir(this.housesAddress);
		this.updateAddress(this.houseAddress);
	} else {
		const { id: storeId } = this.storesAddress.find(s => s.id === deliveryId) || {};
		this.storeAddress = storeId || this.storesAddress[0].id;
		this.updateAddress(this.storeAddress);
	}
}

function favoriteDir(directions) {
	const directionObj = directions.find(d => d.isFavorite);
	return getDeeper('id')(directionObj) || 0;
}

function updateAddress(id) {
	this.$store.commit('SET_DELIVERY_FLAG', false);
	this.$store.commit('SET_WAREHOUSE_FLAG', false);
	if (id) {
		if (this.houseReception) {
			const itemSelected = this.housesAddress.find(equality('id', id));
			this.$store.commit('UPDATE_DELIVERY_ADDRESS', itemSelected);
			this.$store.commit('SET_DELIVERY_FLAG', true);
			this.calculateShippingCost(itemSelected);
		} else {
			const storeSelected = this.storesAddress.find(equality('id', id));
			this.$store.commit('UPDATE_DELIVERY_ADDRESS', storeSelected);
			this.$store.commit('SET_WAREHOUSE_FLAG', true);
		}
		this.$store.commit('SET_NEW_ADDRESS_FLAG', false);
	} else if (!id && this.houseReception) {
		this.$store.commit('SET_DELIVERY_FLAG', true);
		this.$store.commit('SET_NEW_ADDRESS_FLAG', true);
		this.$store.commit('SET_VALID_NEW_ADDRESS', false);
	} else {
		this.$store.commit('UPDATE_DELIVERY_ADDRESS', this.storesAddress[0]);
	}
}

function noDirection() {
	return !this.houseAddress;
}

async function calculateShippingCost(location) {
	const { provinceId } = location;
	const headers = {
		Authorization: `Bearer ${this.token}`,
	};
	const url = '/weight/price';
	const body = this.buildBody(provinceId);
	try {
		const { data: shippingCost } = await this.$httpQtc.post(url, body, { headers });
		this.$store.commit('SET_SHIPPING_COST', shippingCost);
	} catch (error) {
		if (error.data.message === 'PRICE_NOT_CONFIGURATION') {
			this.$store.commit('SET_SHIPPING_COST', null);
			this.$message({
				message: 'No es posible hacer envios a ese destino.',
				type: 'error',
			});
		}
	}
}

function buildBody(provinceId) {
	const details = this.productsSelected.map((p) => {
		const newP = {};
		newP.weight = p.weigth || 0;
		newP.quantity = p.quantity;
		return newP;
	});
	return {
		details,
		provinceId,
	};
}

function isDelivery() {
	return this.deliveryTypes.some(del => del.code === delivery.code);
}

function isStore() {
	return this.deliveryTypes.some(del => del.code === store.code);
}

function deliveryTypes() {
	return getDeeper('deliveryType')(this.getCommerceData) || [];
}

function deliveryHandler() {
	const [deliverySelected] = this.deliveryTypes;
	const deliveryCodeConversion = this.deliveryCodes[deliverySelected.code];
	const orderDelivery = this.orderSummaryInfo && this.orderSummaryInfo.flagPickUp;
	this.active = orderDelivery || deliveryCodeConversion;
	this.clicked(this.active);
}

function data() {
	return {
		active: 0,
		deliveryCodes: {
			RCT: 2,
			EAD: 1,
		},
		houseAddress: 0,
		housesAddress: [
			{ id: 0, addressLine1: 'Nueva dirección', name: 'Nueva dirección' },
		],
		storeAddress: 0,
		storesAddress: [
			{ id: 0, name: 'Seleccione una tienda' },
		],
	};
}

export default {
	name: 'delivery-products',
	components: {
		addressForm,
		locationSvg,
		storeSvg,
		responsibleForm,
		selectAddressComponent,
		specialButton,
		truckSvg,
	},
	computed: {
		...mapGetters([
			'deliveryAddress',
			'flagPickUp',
			'getCommerceData',
			'newAddressFlag',
			'orderSummaryInfo',
			'productsSelected',
			'token',
		]),
		deliveryTypes,
		isDelivery,
		isStore,
		houseReception,
		noDirection,
		storeReception,
	},
	created,
	data,
	methods: {
		buildBody,
		calculateShippingCost,
		clicked,
		deliveryHandler,
		favoriteDir,
		loadData,
		setWarehouseOrDirection,
		updateAddress,
	},
	mixins: [commerceData],
	watch: {
		'getCommerceData.deliveryType': deliveryHandler,
	},
};
</script>


// WEBPACK FOOTER //
// deliveryProducts.vue?9be17588